import _ from 'lodash';
import React from 'react';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import { RESOURCE_DETAIL_URL, INFLUENCER_PREVIEW_URL } from 'global-constants';

import WithPush from 'shared/HOCs/WithPush';

import { formatResourceDate } from 'shared/utils/resource';
import { substituteUrl } from 'shared/utils/substituteUrl';
import { getInfluencerFullName } from 'shared/utils/influencer';

import Button from 'shared/components/Button';
import Image from 'shared/components/Image';

import styles from './styles.module.scss';

const ResourceBox = props => {
  const { resource, imageClassname, imageSize = {}, showButton = true } = props;

  const resourceTypeStyles = {
    backgroundColor: resource.resource_type.color
  };

  const detailUrl = substituteUrl(RESOURCE_DETAIL_URL, {
    resourceSlug: resource.slug
  });

  const redirectToAuthor = () =>
    props.push(
      substituteUrl(INFLUENCER_PREVIEW_URL, {
        influencerSlug: resource.author.slug
      })
    );

  const imageHeight = _.get(imageSize, 'height', 190);
  const imageWidth = _.get(imageSize, 'width', 370);

  return (
    <div className={styles.resourceBoxWrapper}>
      <Link to={detailUrl}>
        <Image
          height={imageHeight}
          width={imageWidth}
          src={resource.image}
          thumbnails={resource.image_thumbnails}
          className={classnames(
            styles.imageContainer,
            styles.imageCover,
            imageClassname
          )}
        />
      </Link>
      {_.get(resource.resource_type, 'name', false) && (
        <div className={styles.resourceTypeName} style={resourceTypeStyles}>
          {resource.resource_type.name.toUpperCase()}
        </div>
      )}
      <Link to={detailUrl} className={styles.title}>
        <h4>{resource.title}</h4>
      </Link>

      <div className={styles.authorAndDate}>
        {resource.author &&
          resource.author.profile && (
            <React.Fragment>
              By{' '}
              <span className={styles.authorNames} onClick={redirectToAuthor}>
                {getInfluencerFullName(resource.author)}
              </span>
              ,
            </React.Fragment>
          )}{' '}
        {formatResourceDate(resource)}
      </div>

      <div className={styles.description}>
        {resource.short_description.substring(0, 115)}
        {_.get(resource, 'short_description.length', 0) > 115 && '...'}
      </div>
      {showButton && (
        <Link to={detailUrl} className={styles.detailButton}>
          <Button type="button" color="dark">
            Read More
          </Button>
        </Link>
      )}
    </div>
  );
};

export default WithPush(ResourceBox);
